import { render, staticRenderFns } from "./infoLabel.vue?vue&type=template&id=16e809f2&scoped=true&"
import script from "./infoLabel.vue?vue&type=script&lang=js&"
export * from "./infoLabel.vue?vue&type=script&lang=js&"
import style0 from "./infoLabel.vue?vue&type=style&index=0&id=16e809f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e809f2",
  null
  
)

export default component.exports